// extracted by mini-css-extract-plugin
export var growableInput = "_60-0";
export var tagContainer = "_60-2";
export var textInput = "_60-1";